/** @jsxImportSource theme-ui */
import { Container, Flex, Heading } from 'theme-ui';
import UsageAuditFilters from '@/containers/voss/UsageAuditFilters';
import UsageAudit from '@/containers/voss/UsageAudit';

const VossUsageAuditPage = () => {
    return (
        <Container>
            <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                <Heading>Voss usage audit</Heading>
                <UsageAuditFilters />
                <UsageAudit />
            </Flex>
        </Container>
    );
};

export default VossUsageAuditPage;
